<template>
  <v-app>
    <TheSideBar />
    <TheContactModal />
    <IdleTimeout />
    <LocaleSelector/>
    <QlikExporter />
    <HelpDoc />
    <v-main id="content">
      <TheNotifier />

      <transition name="fade" mode="out-in">
        <v-container class="fill-height text-center" v-if="$store.state.qlik.isConnecting">
          <v-row justify="center" align="center">
            <v-col cols="12">
              <v-progress-circular
                size="300"
                color="primary"
                indeterminate
                width="20"
              ></v-progress-circular>
            </v-col>
          </v-row>
        </v-container>
        <router-view v-else class="pa-10"/>
      </transition>
    </v-main>
  </v-app>
</template>

<script>
  import TheSideBar from '@/components/Navigation/TheSideBar'
  import TheContactModal from '@/components/Contact/TheContactModal'
  import TheNotifier from '@/components/Notification/TheNotifier'
  import IdleTimeout from '@/components/Utils/IdleTimeout'
  import LocaleSelector from '@/components/Utils/LocaleSelector'
  import QlikExporter from '@/components/Qlik/QlikExporter'
  import HelpDoc from '@/components/Help/HelpDoc'

  import { init } from '@/plugins/qlik'

  export default {
    components: { 
      TheSideBar, 
      TheContactModal,
      TheNotifier,
      IdleTimeout,
      LocaleSelector,
      QlikExporter,
      HelpDoc
    },
    async created () {
      init()
      try {
        await this.$store.dispatch('qlik/connectQlik')
        await this.$store.dispatch('page/loadPages')
      } catch (error) {
        this.$store.dispatch('notify/error', error)
      }
    },
    destroyed () {
      this.$store.dispatch('qlik/disconnectQlik')
    }
  }
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
